// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    AccountTransferAllow: true,
  //  apiBaseUrl: "https://dev.home-connect.co.za/HomeWebapi",
    // apiBaseUrl:"https://portal.home-connect.co.za/Webapi",

    apiBaseUrl: "http://localhost:70",
    Versioning: "2.1.29",

    recaptcha: {
        siteKey: '6Le02HQqAAAAAAiyW3wPgMSq0eU9aNZwAV2zWXjv',
    },

    TokenLength: 400,
    signalRServerUrl: "https://dev.home-connect.co.za/HomeWebapi/signalr/hubs",
    VumaReachUrl: "https://dev-vumareach.home-connect.co.za/checkcoverage",
    Development: true,
    RequestBankingDetails: {
        RequestBankingDetails: "Request Update Banking Details",
        SingleMessageSent: "Send message Sms or Email",
        BulkMessagesSent: "Bulk Messages Sent",
        CannotFindServiceProviderUserList: "The message cannot send the user. User cannot find",
    },
    Microsoft: {
        clientId: '6b33efd8-3ee4-498a-b093-85d733c21548',
        authority: 'https://login.microsoftonline.com/633acf82-28bc-41ca-afa1-c740347908ad',
        redirectUri: 'https://stagingadmin.home-connect.co.za/auth/loginauth',
    }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
